import {
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle
} from 'react'

import IMask, { InputMask } from 'imask'

import Input from '@/components/common/Input/Input'

interface PhoneInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value?: string
  onChange?: (value: string) => void
  label?: string
  error?: string
  className?: string
  disabled?: boolean
  placeholder?: string
  suffix?: React.ReactNode
  countryCode?: string
}

const phoneMask: Record<string, string> = {
  'LT': '+{3}{7}{\\0}00000000',
}

const phonePattern: Record<string, string> = {
  'LT': '\\+[0-9]{3}[0-9]{8}'
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({
    value,
    onChange,
    countryCode = 'LT',
    ...props
  }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null)
    const inputMask = useRef<InputMask>(undefined)

    useImperativeHandle(ref, () => inputRef.current!, [])

    useEffect(() => {
      if (!inputRef.current) return

      inputMask.current = IMask(
        inputRef.current,
        {
          mask: phoneMask[countryCode],
          lazy: false,
        }
      )

      if (value !== undefined) {
        inputMask.current.value = value.toString()
      }

      inputMask.current.on("complete", () => {
        const maskValue = inputMask.current?.value
        onChange?.(maskValue || '')
      })

      return () => {
        inputMask.current?.destroy()
      }
    }, [])

    useEffect(() => {
      if (inputMask.current && value !== undefined) {
        inputMask.current.value = value.toString()
      }
    }, [value])

    return (
      <Input
        pattern={phonePattern[countryCode]}
        ref={inputRef}
        type='tel'
        {...props}
      />
    )
  }
)

PhoneInput.displayName = 'PhoneInput'

export default PhoneInput